import { useState, useEffect } from 'react';
import { useToast } from '../../../Utils/toastContext';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmContinueButton from '../../../Components/ContinueButton/continue-button';
import AddressAutocomplete from '../../../Components/addressInput/address-input';
import { useNavigate } from 'react-router-dom';
import CustomDropdownWithFetch from '../../../Components/CustomDropdown/custom-dropdown-fetchAPI';
import {
  setStepStatus,
  setRejectedFields,
} from '../../../Redux/store/onboardingFormSlice';
import ReviewPopup from '../../../Components/onboarding/review-popup';
import LabelWithStatus from '../../../Components/onboarding/label-with-status';
import { clearFileIdsRedux } from '../../../Redux/store/userSlice';
import ConfirmResetButton from '../../../Components/ContinueButton/reset-button';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const AgentPersonalInfo = ({ setCurrentStep }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const rejectedFields = useSelector((state) => state.form.rejectedFields);
  const updateFieldStatus = useSelector(
    (state) => state.user.updateFieldStatus,
  );
  const [dobError, setDobError] = useState('');

  const [abn, setAbn] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [isValidAbn, setIsValidAbn] = useState(true);

  const isInvitee = useSelector((state) => state.user.isInvitee);
  const isInviteeDirector = useSelector(
    (state) => state.user.isInviteeDirector,
  );
  const stepStatus = useSelector((state) => state.form.stepStatus);

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [firstName, setfirstName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [lastName, setLastName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [middleName, setMiddleName] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [formerNames, setFormerNames] = useState({
    verification_id: null,
    value: [],
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [newFormerName, setFormerName] = useState('');
  const [Dob, setDob] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [apIAddress, setApIAddress] = useState('');
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: 14,
    label: 'Australia',
  });
  const [countryCode, setCountryCode] = useState({
    verification_id: null,
    value: {
      id: 14,
      name: 'Australia',
      risk_factor: 'low',
    },
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCountry, setRedCountry] = useState(null);
  const [redAddress, setRedAddress] = useState({
    verification_id: null,
    value: '',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [redCity, setRedCity] = useState(null);
  const [redState, setRedState] = useState(null);
  const { showToast } = useToast();
  const [showPopup, setShowPopup] = useState(false);
  const [nameFromBirth, setNameFromBirth] = useState({
    verification_id: null,
    value: 'male',
    status: 'pending',
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const userStatus = useSelector((state) => state.user.userStatus);

  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState('');
  const [currentFieldValue, setCurrentFieldValue] = useState('');
  const [currentFieldType, setCurrentFieldType] = useState('');
  const fieldLabelMap = {
    applicant_country_id: "Applicant's Country",
    profile_picture_file: 'Profile Picture',
    first_name: 'First Name',
    last_name: 'Last Name',
    middle_name: 'Middle Name',
    gender: 'Gender',
    former_names: 'Former Name(s)',
    dob: 'Date Of Birth',
    address_id: 'Residential Address',
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const handleReset = async () => {
    let toastMessage = null;
    try {
      const response = await resetApplicationAPI();
      if (response.status == 200) {
        toastMessage = {
          message: response.message,
          type: 'success',
        };
        getDetailsWithVerification();
        const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
        if (responseStatus.status == 200) {
          if (responseStatus.data.length > 0) {
            dispatch(setStepStatus(responseStatus.data));
          }
        }
        const responseRejected = await GetAPIcalls(
          `/api/v1/onboarding/rejected-fields`,
        );
        if (responseRejected.status == 200) {
          dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleBack = () => {};
  const getAllLocationDetails = async () => {
    try {
      const response = await getLocation(
        redAddress.value.country &&
          redAddress.value.country.name &&
          redAddress.value.country.name !== ''
          ? redAddress.value.country.name
          : redAddress.value.country,
        redAddress.value.state &&
          redAddress.value.state.name &&
          redAddress.value.state.name !== ''
          ? redAddress.value.state.name
          : redAddress.value.state,
        redAddress.value.city &&
          redAddress.value.city.name &&
          redAddress.value.city.name !== ''
          ? redAddress.value.city.name
          : redAddress.value.city,
      );
      setRedCountry(response.country_id);
      setRedState(response.state_id);
      setRedCity(response.city_id);
    } catch (err) {
      setRedCountry(null);
      setRedState(null);
      setRedCity(null);
      showToast(err.message, 'error');
    }
  };
  const handleDobChange = (date) => {
    const value = date;

    if (!is18Plus(value)) {
      setDobError('You must be at least 18 years old');
    } else {
      setDobError('');
    }

    setDob({
      ...Dob,
      value,
    });
  };
  const is18Plus = (date) => {
    const today = new Date();
    const dob = new Date(date);

    const age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    if (
      age > 18 ||
      (age === 18 && monthDiff > 0) ||
      (age === 18 && monthDiff === 0 && today.getDate() >= dob.getDate())
    ) {
      return true;
    }
    return false;
  };
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/users/countries?size=250`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
            risk_factor: profile.risk_factor,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  const getCountries = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 10; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/api/v1/users/countries?page=${page}&size=${size}&search=${
          searchTerm || ''
        }`,
      );

      if (response.status === 200) {
        const items = response.data.countries.map((item) => ({
          value: item.id,
          label: item.name,
          risk_factor: item.risk_factor,
        }));

        return {
          items,
          hasMore: response.data.countries.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, 'error');
      return { items: [], hasMore: false };
    }
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };

  const getDetailsWithVerification = async () => {
    try {
      const response = await GetAPIcalls(
        `/api/v1/onboarding/agent/details/verification/preview`,
      );

      if (response.status == 200) {
        if (response.data) {
          setfirstName(response.data.first_name);
          setLastName(response.data.last_name);
          setMiddleName(response.data.middle_name);
          setNameFromBirth(response.data.gender);
          setFormerNames(response.data.former_names);
          setDob(response.data.dob);
          setCountryCode(response.data.applicant_country);
          setpreselectedCountryCode({
            value: response.data.applicant_country.value.id,
            label: response.data.applicant_country.value.name,
          });
          setApIAddress(response.data.address.value);
          setRedAddress(response.data.address);
        } else {
          setfirstName({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setLastName({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setMiddleName({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setNameFromBirth({
            verification_id: null,
            value: true,
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setFormerNames({
            verification_id: null,
            value: [],
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setDob({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setCountryCode({
            verification_id: null,
            value: {
              id: 14,
              name: 'Australia',
              risk_factor: 'low',
            },
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          setpreselectedCountryCode({
            value: 14,
            label: 'Australia',
          });
          setApIAddress('');
          setRedAddress({
            verification_id: null,
            value: '',
            status: 'pending',
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
        }
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };

  const handleNameFromBirth = (e) => {
    setNameFromBirth({
      ...nameFromBirth,
      value: e.target.value,
    });
  };
  const checkFields = () => {
    const validations = [
      {
        condition: !firstName.value,
        message: 'Please enter a valid first name',
      },
      { condition: !lastName.value, message: 'Please enter a valid last name' },
      {
        condition: !redAddress.value || !redCountry,
        message: 'Please enter a valid residential address',
      },
      { condition: !Dob.value, message: 'Please enter a valid date of birth' },
      { condition: !countryCode.value.id, message: 'Please select country' },
    ];

    for (const { condition, message } of validations) {
      if (condition) {
        showToast(message, 'error');
        return true;
      }
    }

    return false;
  };

  const handleContinue = async (isFinal) => {
    if (isFinal) {
      if (!checkFields()) {
        setLoading(true);
        handlesave(isFinal);
      }
    } else {
      setLoading(true);
      handlesave(isFinal);
    }
  };

  const handleAddFormerName = (e) => {
    if (e.key === 'Enter' && newFormerName.trim() !== '') {
      setFormerNames((prev) => {
        const existingValues = Array.isArray(prev?.value)
          ? prev.value
          : prev?.value
            ? [prev.value]
            : [];

        return {
          ...prev,
          value: [...existingValues, newFormerName.trim()],
        };
      });

      setFormerName(''); // clear input
    }
  };

  const handleRemoveFormerName = (indexToRemove) => {
    setFormerNames((prev) => ({
      ...prev,
      value: prev.value.filter((_, index) => index !== indexToRemove),
    }));
  };
  const handleSelectCountryCode = (selectedOption) => {
    setCountryCode({
      ...countryCode,
      value: {
        id: selectedOption.value,
        name: selectedOption.label,
        risk_factor: selectedOption.risk_factor,
      },
    });
  };
  const formatDate = (date) => {
    if (!date) return '';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    if (Dob.value && typeof Dob.value === 'string') {
      setDob({
        ...Dob,
        value: new Date(Dob.value), // convert string to Date
      });
    }
  }, [Dob.value]);

  const submitApplicationAPI = async (isFinal, payloadAddress) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let isOnbaording = userStatus == 'onboarding' ? true : false;
    let apiUrl = isOnbaording
      ? `${BASE_URL}/api/v1/onboarding/agent/details/submit`
      : `${BASE_URL}/api/v1/onboarding/agent/details/update`;

    let bodyData = {
      first_name: firstName.value,
      last_name: lastName.value,
      middle_name: middleName.value,
      gender: nameFromBirth.value == true ? 'male' : 'female',
      former_names: formerNames.value,
      dob: formatDate(Dob.value),
      applicant_country_id: countryCode.value.id,
      address: payloadAddress,
      is_submitted: isFinal,
    };

    try {
      const response = await fetch(apiUrl, {
        method: isOnbaording ? 'POST' : 'PUT',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const resetApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/agent/details/reset`;
    let bodyData = {};
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const getLocation = async (country, state, city) => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/onboarding/location/ids`;

    let bodyData = {
      country: country,
      state: state,
      city: city,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const isValidAddress = (addr) => {
    if (!addr || typeof addr !== 'object') return false;

    return (
      addr.address_line_1 ||
      addr.city_id ||
      addr.zip_code ||
      addr.google_address
    );
  };
  const handlesave = async (isFinal) => {
    let toastMessage = null;
    try {
      let payloadAddress = {};
      if (apIAddress != null) {
        payloadAddress = {
          address_line_1:
            apIAddress.address_line_1 == null
              ? apIAddress.google_address
              : apIAddress.address_line_1,
          address_line_2:
            apIAddress.address_line_2 == null
              ? null
              : apIAddress.address_line_2,
          city_id: apIAddress.city != null ? apIAddress.city.id : null,
          state_id: apIAddress.city != null ? apIAddress.city.state_id : null,
          country_id: redCountry,
          zip_code: apIAddress.postal_code,
          google_address: apIAddress.google_address,
        };
      } else {
        if (redAddress.value) {
          payloadAddress = {
            address_line_1:
              redAddress.value.street == ''
                ? redAddress.value.full
                : redAddress.value.street,
            address_line_2: redAddress.value.route,
            city_id: redCity,
            state_id: redState,
            country_id: redCountry,
            zip_code: redAddress.value.zip,
            google_address: redAddress.value.full,
          };
        }
      }
      // if (payloadAddress.city_id === null) {
      //   showToast("Please select a valid city before proceeding.", "error");
      //   return; // Stop execution if city_id is missing
      // }
      const response = await submitApplicationAPI(isFinal, payloadAddress);
      if (response.status == 200) {
        if (isFinal) {
          setCurrentStep(2);
          toastMessage = {
            message: response.message,
            type: 'success',
          };
          const responseStatus = await GetAPIcalls(`/api/v1/onboarding/status`);
          if (responseStatus.status == 200) {
            if (responseStatus.data.length > 0) {
              dispatch(setStepStatus(responseStatus.data));
            }
          }
          const responseRejected = await GetAPIcalls(
            `/api/v1/onboarding/rejected-fields`,
          );
          if (responseRejected.status == 200) {
            dispatch(setRejectedFields(responseRejected.data)); // <-- Save in Redux
          }
        } else {
          toastMessage = {
            message:
              'Information has been saved successfully. Please submit to proceed further.',
            type: 'success',
          };
        }
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  useEffect(() => {
    getAllCountries();
  }, []);
  useEffect(() => {
    if (stepStatus.length > 0 && stepStatus[0].status != 'DRAFT') {
      getDetailsWithVerification();
    }
  }, [stepStatus]);
  useEffect(() => {
    if (
      updateFieldStatus &&
      stepStatus.length > 0 &&
      stepStatus[0].status != 'DRAFT'
    ) {
      getDetailsWithVerification();
    }
  }, [stepStatus, updateFieldStatus]);
  useEffect(() => {
    if (
      (redAddress.value && redAddress.value.country) ||
      (redAddress.value && redAddress.value.country.name)
    ) {
      getAllLocationDetails();
    }
  }, [redAddress]);
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {countryCode.value && countryCode.value.risk_factor == 'high' && (
          <div className="mb-2 bg-red-100 border-l-4 border-red-500 text-red-700 p-3 rounded-md text-sm flex items-center">
            <img src="/tick-error.svg" alt="Info" className="w-5 h-5 mr-2" />
            <span>
              It looks like we’re
              <strong> not able to accept applications</strong> from this
              country at the moment.{' '}
            </span>
          </div>
        )}
        {stepStatus.length > 0 &&
          (stepStatus[0].status == 'IN_REVIEW' ||
            stepStatus[0].status == 'COMPLETED') && (
            <div className="mb-2 bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-3 rounded-md text-sm flex items-center">
              <img
                src="/warning-circle.svg"
                alt="Info"
                className="w-4 h-4 mr-2"
              />
              <span>
                This section is{' '}
                <strong>in review by our onboarding team</strong>. You will be
                notified once the verification is complete.{' '}
              </span>
            </div>
          )}

        {stepStatus.length > 0 && stepStatus[0].status == 'APPROVED' && (
          <div className="mb-2 bg-green-100 border-l-4 border-green-500 text-green-700 p-3 rounded-md text-sm flex items-center">
            <span>
              This section has been <strong>approved</strong> by our onboarding
              team.
            </span>
          </div>
        )}
        {rejectedFields?.AGENT_DETAILS?.rejected_fields?.length > 0 && (
          <div className="mb-3 p-3 bg-red-50 border border-red-200 rounded-md">
            <p className="font-semibold text-red-700 mb-1">
              {rejectedFields.AGENT_DETAILS.rejected_fields.length === 1
                ? 'The following field requires correction:'
                : 'The following fields require correction:'}{' '}
            </p>

            <div className="flex flex-wrap gap-2">
              {rejectedFields.AGENT_DETAILS.rejected_fields.map((field) => (
                <span
                  key={field}
                  className="px-2 py-1 bg-red-100 text-red-700 text-xs rounded"
                >
                  {fieldLabelMap[field] || field.replace(/_/g, ' ')}
                </span>
              ))}
            </div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <img
              src="/profile-circle-black.svg"
              alt="User Avatar"
              className="h-6 w-6 mb-2"
            />
            <h1 className="text-xl font-medium mb-2">Personal Information</h1>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6">
            <div className="flex lg:pt-4 pt-0 flex-col md:px-4">
              <div className="">
                <CustomDropdownWithFetch
                  label={
                    <>
                      {fieldLabelMap.applicant_country_id}
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={countryCodeData}
                  search={true}
                  preselectedValue={preselectedCountryCode}
                  onSelect={handleSelectCountryCode}
                  colorLabel=""
                  fetchOptions={getCountries} // <-- pass fetch function, not options
                />
              </div>
            </div>
          </div>
          {countryCode.value && countryCode.value.risk_factor != 'high' && (
            <div className="bg-white">
              <div className="flex items-center border-b border-colour-custom space-x-2  pb-2"></div>

              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                  <div className="">
                    <LabelWithStatus
                      id="firstName"
                      label={fieldLabelMap.first_name}
                      required={true}
                      fieldData={firstName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      value={firstName.value}
                      placeholder="Your First Name"
                      disabled={
                        isInvitee ||
                        isInviteeDirector ||
                        firstName.status == 'approved'
                      }
                      className={`${
                        firstName.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setfirstName({
                          ...firstName,
                          value: e.target.value,
                        })
                      }
                    />
                    <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                      First Name as per identification documentation
                    </p>
                  </div>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="lastName"
                      label={fieldLabelMap.last_name}
                      required={true}
                      fieldData={lastName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      disabled={
                        isInvitee ||
                        isInviteeDirector ||
                        lastName.status == 'approved'
                      }
                      value={lastName.value}
                      placeholder="Your Last Name"
                      className={`${
                        lastName.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setLastName({
                          ...lastName,
                          value: e.target.value,
                        })
                      }
                    />
                    <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                      Last Name as per identification documentation
                    </p>
                  </div>{' '}
                  <div className="mt-4">
                    <LabelWithStatus
                      id="middleName"
                      label={fieldLabelMap.middle_name}
                      required={false}
                      fieldData={middleName}
                      handleStatusClick={handleStatusClick}
                    />
                    <input
                      id="middleName"
                      name="middleName"
                      type="text"
                      value={middleName.value}
                      placeholder="Your Middle Name"
                      disabled={middleName.status == 'approved'}
                      className={`${
                        middleName.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                      onChange={(e) =>
                        setMiddleName({
                          ...middleName,
                          value: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="formerNames"
                      label={fieldLabelMap.former_names}
                      required={false}
                      fieldData={formerNames}
                      handleStatusClick={handleStatusClick}
                    />
                    <div
                      className={`${
                        formerNames.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : 'border-gray-300'
                      } mt-1 border rounded-md  p-2 flex flex-wrap gap-2`}
                    >
                      {formerNames.value && formerNames.value.length > 0 && (
                        <>
                          {formerNames.value.map((formerName, index) => (
                            <div
                              key={index}
                              className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                            >
                              <span>{formerName}</span>
                              <button
                                type="button"
                                onClick={() => handleRemoveFormerName(index)}
                                className="ml-2 text-gray-700 hover:text-gray-700"
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </>
                      )}

                      <input
                        type="text"
                        value={newFormerName}
                        onChange={(e) => setFormerName(e.target.value)}
                        onKeyDown={handleAddFormerName}
                        placeholder="Add name"
                        className="border-none focus:outline-none flex-grow text-sm"
                        disabled={formerNames.status == 'approved'}
                      />
                    </div>
                  </div>
                </div>{' '}
                <div className="space-y-4 lg:pt-4 pt-0 sm:border-r-0 md:border-r border-gray-300 px-4 md:pl-0 pr-4">
                  <div className="w-full">
                    <LabelWithStatus
                      id="Dob"
                      label={fieldLabelMap.dob}
                      required={true}
                      fieldData={Dob}
                      handleStatusClick={handleStatusClick}
                    />
                    <div className="w-full">
                      <DatePicker
                        selected={Dob.value}
                        onChange={handleDobChange}
                        dateFormat="dd/MM/yyyy"
                        minDate={new Date(1900, 0, 1)}
                        maxDate={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() - 18,
                            ),
                          )
                        }
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="scroll" // 🔥 FIX (instead of "select")
                        yearDropdownItemNumber={100} // 🔥 show 100 years
                        scrollableYearDropdown // 🔥 smooth scroll
                        placeholderText="Select Date of Birth"
                        wrapperClassName="w-full"
                        className={`w-full p-2 border rounded-md ${
                          Dob.status == 'rejected'
                            ? 'border-red-500'
                            : 'border-gray-300'
                        }`}
                      />

                      {/* Error Message */}
                      {dobError && (
                        <p className="text-red-500 text-xs mt-1">{dobError}</p>
                      )}
                    </div>
                  </div>
                  <div className="mt-4 flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                    <LabelWithStatus
                      id="birthName"
                      label={fieldLabelMap.gender}
                      required={true}
                      fieldData={nameFromBirth}
                      handleStatusClick={handleStatusClick}
                    />
                    {/* Radio Buttons */}
                    <div className="flex items-center gap-4">
                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="birthName"
                          value="male"
                          checked={nameFromBirth.value == 'male'}
                          onChange={handleNameFromBirth}
                          disabled={nameFromBirth.status == 'approved'}
                          className={`${
                            nameFromBirth.status == 'rejected'
                              ? 'border-[#FF5050] border-2'
                              : 'border-gray-300'
                          } confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]`}
                        />
                        <span className="">Male</span>
                      </label>

                      <label className="flex items-center text-sm text-black">
                        <input
                          type="radio"
                          name="birthName"
                          value="female"
                          checked={nameFromBirth.value == 'female'}
                          onChange={handleNameFromBirth}
                          disabled={nameFromBirth.status == 'approved'}
                          className={`${
                            nameFromBirth.status == 'rejected'
                              ? 'border-[#FF5050] border-2'
                              : 'border-gray-300'
                          } confirm-check w-6 h-4 text-[#375AE7]  focus:ring-[#375AE7]`}
                        />
                        <span className="">Female</span>
                      </label>
                    </div>
                  </div>
                  <div className="mt-4">
                    <LabelWithStatus
                      id="companyLogo"
                      label="Real Estate License Number"
                      required={false}
                      fieldData={abn}
                      handleStatusClick={handleStatusClick}
                    />
                    <div
                      className={`${
                        abn.status == 'rejected'
                          ? 'border-[#FF5050] border-2'
                          : ''
                      }  flex items-center border px-2 rounded-lg w-full`}
                    >
                      <input
                        id="abn"
                        name="abn"
                        type="text"
                        value={abn.value}
                        placeholder="Enter Number"
                        disabled={abn.status == 'approved'}
                        // onBlur={validateAbn}
                        className={` h-[2.813rem] dark:focus-visible:ring-[#4E4E4E] dark:text-white text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none  w-full leading-tight focus:outline-none focus:shadow-outline`}
                        onChange={(e) => {
                          setAbn({
                            ...abn,
                            value: e.target.value,
                          });
                          setIsValidAbn(false);
                        }}
                      />
                      {/* {isValidAbn != null && (
                      <span
                        className={`material-symbols-outlined ml-2 text-xl transition-all duration-300 ${
                          isValidAbn
                            ? "text-green-500 scale-110"
                            : "text-red-500 scale-110"
                        }`}
                      >
                        {isValidAbn ? "check_circle" : "cancel"}
                      </span>
                    )} */}
                    </div>
                  </div>
                </div>
                {/* Client ID Section */}
                <div className="flex lg:pt-4 pt-0 flex-col px-4 md:px-0 pr-4">
                  <div className="">
                    <LabelWithStatus
                      id="ResidentialAddress"
                      label={fieldLabelMap.address_id}
                      required={true}
                      fieldData={redAddress}
                      handleStatusClick={handleStatusClick}
                    />
                    <AddressAutocomplete
                      value={
                        redAddress?.value?.full ||
                        apIAddress?.google_address ||
                        ''
                      }
                      disabled={redAddress.status == 'approved'}
                      className={
                        redAddress.status == 'rejected'
                          ? 'border-[#FF5050] border-2 w-full'
                          : 'w-full'
                      }
                      onSelect={(addr) => {
                        setApIAddress(null);
                        setRedAddress({
                          ...redAddress,
                          value: addr,
                        });
                      }}
                    />
                  </div>
                  <p className="text-[10px] mt-1 text-[#363636] bg-[#363636] border-gray-300 bg-opacity-20 px-2 py-1 border-2 rounded-lg">
                    PLEASE MAKE SURE THE PROVIDED ADDRESS MATCHES THE DOCUMENT
                    PROOFS YOU PROVIDE.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {showPopup && currentField && (
        <ReviewPopup
          isOpen={showPopup}
          currentField={currentField}
          currentFieldName={currentFieldName}
          currentFieldValue={currentFieldValue}
          currentFieldType={currentFieldType}
          onClose={() => setShowPopup(false)}
        />
      )}
      {countryCode.value && countryCode.value.risk_factor != 'high' && (
        <footer className=" bottom-actions flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#375AE7]">
          {stepStatus.length > 0 &&
            stepStatus[0].status != 'COMPLETED' &&
            stepStatus[0].status != 'APPROVED' &&
            stepStatus[0].status != 'IN_REVIEW' && (
              <>
                <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
                  <ConfirmResetButton
                    onConfirm={handleReset}
                    isReset={true}
                    isBack={false}
                    onBack={handleBack}
                  />
                </div>
                <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                  {/* Save as Draft */}
                  <button
                    onClick={() => {
                      handleContinue(false);
                    }}
                    className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                  >
                    <span>Save as Draft</span>
                  </button>

                  <ConfirmContinueButton
                    onContinue={() => handleContinue(true)}
                    buttonText="Continue"
                    confirmTitle="Save Section"
                    confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
                  />
                </div>
              </>
            )}
          {stepStatus.length > 0 &&
            (stepStatus[0].status == 'COMPLETED' ||
              stepStatus[0].status == 'APPROVED' ||
              stepStatus[0].status == 'IN_REVIEW') && (
              <div className="flex flex-col md:flex-row items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4 relative">
                {/* Save as Draft */}
                <button
                  onClick={() => {
                    setCurrentStep(2);
                  }}
                  className="flex w-full md:w-auto items-center justify-center space-x-2 border-2 border-white text-white font-medium py-2 px-4 rounded-full text-sm"
                >
                  <span>Next</span>
                </button>
              </div>
            )}
        </footer>
      )}
    </div>
  );
};

export default AgentPersonalInfo;
